import HookFormSwitchInput from 'src/hook-form-wrapper/switch-input';
import React from 'react';
import {useTranslations} from 'src/providers/translation';
import {IDeveloperField} from 'dromo-uploader-react';
import {DataItem} from 'src/design-system';
import {Text} from 'react-native';
import {Typography} from 'src/styles';

interface DisplayProps {
  value: boolean;
}

interface Props {
  name?: string;
}

export const Import = (
  key: string = 'intensity',
  prefix?: string,
): IDeveloperField => ({
  label: (prefix ? prefix + ' ' : '') + 'Intensity Tracker',
  key,
  type: 'checkbox',
});

export const Value = (value: boolean) => {
  return value ? 'On' : 'Off';
};

export const Display = ({value}: DisplayProps) => {
  const translations = useTranslations();
  return (
    <DataItem>
      <Text style={[Typography.H6]}>{translations('intensity_tracker')}</Text>
      <Text style={[Typography.P3]}>{Value(value)}</Text>
    </DataItem>
  );
};

export const Input = ({name}: Props) => {
  const translations = useTranslations();

  return (
    <HookFormSwitchInput
      name={(name ? name + '.' : '') + 'intensity'}
      label={translations('intensity_tracker')}
      description={translations('intensity_tracker_description')}
    />
  );
};

export default Input;
